import { apiFetch } from "./api";
import { ReferralListResponse, ReferralDetail } from "../types/fyo";

export interface ReferralFilters {
  name?:             string;
  status?:           string;
  manual_review?:    boolean;
  referred_company?: string;
  loop_closed?:      boolean;
  window_expired?:   boolean;
  limit?:            number;
  offset?:           number;
}

export function fetchReferrals(filters: ReferralFilters = {}): Promise<ReferralListResponse> {
  const q = new URLSearchParams();
  if (filters.name)                   q.set("name",             filters.name);
  if (filters.status)                 q.set("status",           filters.status);
  if (filters.manual_review)          q.set("manual_review",    "true");
  if (filters.referred_company)       q.set("referred_company", filters.referred_company);
  if (filters.loop_closed != null)    q.set("loop_closed",      String(filters.loop_closed));
  if (filters.window_expired != null) q.set("window_expired",   String(filters.window_expired));
  q.set("limit",  String(filters.limit  ?? 50));
  q.set("offset", String(filters.offset ?? 0));
  return apiFetch(`/referrals?${q}`);
}

export function fetchReferralDetail(opportunityResourceId: number | string): Promise<ReferralDetail> {
  return apiFetch(`/referrals/${opportunityResourceId}`);
}

export function patchReferral(id: number, payload: Record<string, any>): Promise<void> {
  return apiFetch(`/referrals/${id}`, { method: "PATCH", body: JSON.stringify(payload) });
}

